/**
 * Coalesce identical in-flight requests (and optional short TTL cache)
 * so React Strict Mode double-mounts do not duplicate API traffic.
 */

const inflight = new Map();
const settled = new Map();

export function dedupeInflight(key, fn, { cacheMs = 0 } = {}) {
  if (!key) {
    return Promise.resolve().then(fn);
  }

  if (cacheMs > 0) {
    const cached = settled.get(key);
    if (cached && Date.now() - cached.at < cacheMs) {
      return Promise.resolve(cached.value);
    }
  }

  if (inflight.has(key)) {
    return inflight.get(key);
  }

  const promise = Promise.resolve()
    .then(fn)
    .then((value) => {
      if (cacheMs > 0) {
        settled.set(key, { value, at: Date.now() });
      }
      return value;
    })
    .finally(() => {
      inflight.delete(key);
    });

  inflight.set(key, promise);
  return promise;
}

export function clearDedupeCache(key) {
  if (key) {
    settled.delete(key);
    return;
  }
  settled.clear();
}
